<template>
    <v-app class="white">
        <!-- 상단타이틀 -->
        <div class="top-bg">
             <!-- 배경 -->
            <img 
            src="@/assets/top_bg.png"
            class="img-top-bg"> 
            <!-- 타이틀 -->
            <div class="top-title">
                푸시설정
            </div> 
            <!-- 뒤로가기 버튼 -->
            <div class="top-backkey"
            @click.passive="onClickBack"
            v-ripple="{ center: true, class: `teal--text`  }">
                <img 
                src="@/assets/backkey.png"
                class="img-backkey"> 
            </div>  
        </div> 
    </v-app>
</template>
<script>
import axios from 'axios';
export default {
  created() {
      this.mEmail = this.$route.query.email;
      this.mSnsKey = this.$route.query.sns_key;
      console.log("email :: " + this.mEmail )
      console.log("mSnsKey :: " + this.mSnsKey )
      console.log("sdfsdf :: " + this.$httpConst.URL)
  },
  data: () => ({
      mPass00 : "",
      mPass01 : "",
      mRecomCode : "",
      mEmail : "",
      mSnsKey : "",
      mMarket : "AND",
      mLang : "KOR",
      mTokenID : "",
  }),
  methods : {
        onClickNext : function() {

        },
        onClickBack : function() {
            this.$router.go(-1);  
        }
  }
}
</script>
<style scoped>
* {
    margin: 0;
    font-family: "NanumBarunGothicOTF", "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif; 
    font-weight: 300;
    padding: 0;
}
html, body {
    height: 100vh;
    width: 100vw;
}
.img-logo {
    height: 36.85vw;
    width: 63.9vw;
}
.logo-img-position {
    position: absolute;
    top: 39.6vh;
    left: 18.1vw;
}
.copyright-position {
    position: absolute;
    bottom: 4.2vh;
    left: 15.88889vw;
}
.img-copyright {
    height: 3.3vw;
    width: 68.5vw;
}
.top-bg {
    position: absolute;
    top: 0vh;
    left: 0vw;
}
.img-top-bg {
    height: 13.24vw;
    width: 100vw;
}
.top-backkey {
    position: absolute;
    top: 0vh;
    left: 0vw;      
    height: 13.24vw;
    width: 13.24vw;
}
.img-backkey {
    position: absolute;
    top: 4.07vw;
    left: 5.64vw;
    height: 5.277vw;
    width: 2.77vw;
}
.top-title {
    position: absolute;
    top: 50%; 
    left: 50%;
    width: auto;
    height: auto;
    font-family: NanumBarunGothicOTF;
    font-size: 3.7vw;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #345993;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
    pointer-events: none;  
}
.btn-next-bg {
    position: absolute;
    bottom: 0px; 
    left: 0px;
    width: 100vw;
    height: 14.35vw; 
    background-color: #345993;
}
.txt-next {
    position: absolute;
    top: 50%; 
    left: 50%;
    width: auto;
    height: auto; 
    text-align: center;
    color: white;
    font-size: 4.148vw;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
    pointer-events: none; 
}
.txt-password {
    position: absolute;
    top: 17.35vw; 
    left: 5.9vw;
    color : #345993;
    font-size: 3.22vw;
    font-weight: bold;
    font-family: NanumBarunGothicOTF;
}
.input-pwd-position {
    position: absolute;
    top: 21.8vw; 
    left: 5.6vw;
}
.img-input-pwd {
    height: 8.88vw;
    width: 88.9vw;
}
.txt-retry-password {
    position: absolute;
    top: 36.148vw; 
    left: 5.6vw;
    color : #345993;
    font-weight: bold;
    font-size: 3.22vw;
    font-family: NanumBarunGothicOTF;
}
.input-retry-pwd-position {
    position: absolute;
    top: 40.74vw; 
    left: 5.6vw;
}
.notice-text-00 {
    position: absolute;
    top: 53.37vw; 
    left: 6.1vw; 
    font-size: 2.7vw;
    font-weight: 300;
    font-family: NanumBarunGothicOTF; 
    color : #918b8a;      
}
.notice-text-01 {
    position: absolute;
    top: 57.4vw; 
    left: 6.1vw; 
    right: 6.1vw;
    width: auto;
    height: auto; 
    font-size: 2.7vw;
    font-weight: 300;
    font-family: NanumBarunGothicOTF; 
    color : #918b8a;     
}
.txt-recomm-code {
    position: absolute;
    top: 75.92vw; 
    left: 5.9vw;  
    color: #345993;   
    font-size: 3.22vw;
    font-weight: bold;
    font-family: NanumBarunGothicOTF;     
}
.input-recomm-positon {
    position: absolute;
    top: 80.55vw; 
    left: 5.9vw;      
}
.bottom-line {
    position: absolute;
    top: 70.92593vw; 
    left: 0vw;    
    width: 100vw;
    height: 5px;
    background-color: #f3f6fb;  
}
.input-pwd-00 {
    position: absolute;
    top: 20%; 
    left: 0vw;  
    width: 100%;
    height: auto;
    padding-left: 5vw;
    font-size: 3.2vw;
}
.input-pwd-01 {
    position: absolute;
    top: 20%; 
    left: 0vw;  
    width: 100%;
    height: auto;    
    padding-left: 5vw;
    font-size: 3.2vw;
}
.input-recom-code {
    position: absolute;
    top: 20%; 
    left: 10vw;
    right: 10vw;  
    width: 100%;
    height: auto;    
    padding-left: 5vw;
    font-size: 3.2vw;
}
.main-content {
    position: absolute;
    top: 70.92593vw; 
    left: 0vw; 
    left: 10vw;
    text-align: center;
    right: 10vw; 
    font-size: 3.2vw; 
}
</style>